/** @jsx builderX.jsx */

import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='waitingPopup'>
        <Image src='loader' />
    </Sprite>
);
